
import LoandSideBar from "../LoansSideBar"
import loanCss from "../../../css/loansListing.module.css"
import React from 'react';
import { useState, useEffect, useRef } from "react";
import { useHistory, useParams } from 'react-router-dom';
import Select from "react-select";
import { toast } from "react-toastify";

import { ReactComponent as FilterIcon } from "../../../assets/icons/filter.svg"
import { ReactComponent as Plus } from "../../../assets/icons/plus.svg"
import { ReactComponent as CalenderIcon } from "../../../assets/icons/calenderIcon.svg"
import { ReactComponent as CustModeLCloseIcon } from '../../../assets/icons/custModeLCloseIcon.svg'
import { ReactComponent as LoansUploadIcon } from '../../../assets/icons/loansUploadIcon.svg'
import { ReactComponent as RemoveLoanIcon } from '../../../assets/icons/removeLoansIcons.svg'

import { loansListing, UploadLoanFiles, GetLoanMapping, saveLoanMapping, GetSubLoanMapping, submapping, getAllLoansErpData, putLoanFromERP } from '../../../../Bookclosure/Services/ApiHandler'

import Table from "../../../elements/Table"
import ListingFilterModel from "../../../components/loans/Listing/ListingFilterModel"
import commoncss from "../../../css/common.module.css";
import AddLoanRegister from "../AddLoanRegister/AddLoanRegister";
import ERPModal from "../ERPModal/ERPModal";
import SyncERPSuccess from "../../../fixedassetelements/SyncButton/SyncERPSuccess";
import ErrorPopup from "../../../elements/ErrorPopup";
import SuccessPopup from "../../../elements/SuccessPopup";

const ReceivablesListing = () => {
    // const [loanID, setloanID] = useState('676cf724e5e1156fbf63b571')
    const { id, companyId } = useParams();
    // const [loanID, setloanID] = useState('6762fea33c390b53069845b4')
    const [loanID, setloanID] = useState(id)
    const [loansUploadModal, setLoanUploadModal] = useState(false)
    const [showAddRegisterModal, setShowAddRegisterModal] = useState(false);
    const [showERPModal, setShowERPModal] = useState(false);
    const [showERPSuccessModal, setShowERPSuccessModal] = useState(false);
    const [erpList, setErpList] = useState([]);
    const [selectedCardId, setSelectedCardId] = useState(null);
    const [isErpLoading, setIsErpLoading] = useState(false);
    const [errorPopup, setErrorPopup] = useState({ isOpen: false, title: "Error", message: "" });
    const [successPopup, setSuccessPopup] = useState({ isOpen: false, title: "Success", message: "" });

    // loan Mapping model
    const [loanMapping, setloanMapping] = useState(false)

    // loan Mapping model
    const [subloanMapping, setsubloanMapping] = useState(false)

    const [loansListThData, setloansListThData] = useState()
    const [loansListTbData, setloansListTbData] = useState()

    const [loansColumnMapVal, setloansColumnMapVal] = useState({}); // Initialize to an empty object
    const [loansColumnMap, setloansColumnMap] = useState([])

    const [subMappingActiveTab, setsubMappingActiveTab] = useState(1)

    const [perIndAsLabels, setperIndAsLabels] = useState()
    const [perIndAsFields, setperIndAsFields] = useState()

    const [perRBILables, setperRBILables] = useState()
    const [perRBIFields, setperRBIFields] = useState()

    const [perProductClassfLables, setperProductClassfLables] = useState()
    const [perProductClassfFields, setperProductClassfFields] = useState()

    const [selectedSubMappingData, setSelectedSubMappingData] = useState({
        RBIStages: [],
        IndASStages: [],
        productClassificationStages: []
    });
    const [filterAttr, setFilterAttr] = useState([]);
    const [filterLoanData, setFilterLoanData] = useState({}); // <-- State for filter data
    const handleSetSelectChange = (selectedOption, index, tab) => {
        let label = '';
        if (tab === 'IndAS') label = perIndAsLabels[index];
        else if (tab === 'RBI') label = perRBILables[index];
        else if (tab === 'productClassification') label = perProductClassfLables[index];

        setSelectedSubMappingData(prev => {
            const updated = [...prev[tab + 'Stages']];
            updated[index] = {
                key: label || '', // ensure key is always set
                values: [selectedOption.value]
            };
            return {
                ...prev,
                [tab + 'Stages']: updated
            };
        });
    };

    useEffect(() => {
        setloansColumnMapVal({
            // Basic Customer and Loan Identifiers
            "customerID": "CustomerID3",                      // Maps to Excel column: CustomerID3
            "customerName": "ApplicantName3",                 // Maps to Excel column: ApplicantName3
            "productID": "Product  ID3",                      // Maps to Excel column: Product  ID3
            "productName": "Product name",                    // Maps to Excel column: Product name
            "loanID": "LegacyID",                             // Maps to Excel column: LegacyID
            "loanName": "LegacyID",                           // Same as loanID
            "sanctionAmount": " Cumm_Sanction_Amt ",          // Maps to Excel column with spaces
            "sanctionDate": "Sanc. Date",                     // Maps to: Sanc. Date
            "sanctionedROI": " Sanction_ROI ",                // Maps to: Sanction_ROI
            "currentOrRevisedROI": " Revised_ROI ",           // Maps to: Revised_ROI
            "sanctionedNumberOfMonths": "Sanction_Term",      // Maps to: Sanction_Term
            "remainingNumberOfMonths": " Revised_Term ",      // Maps to: Revised_Term
            "overdueDays": "OD days after link",              // Maps to: OD days after link
            "loanOutstanding": " Final Loan O/s ",            // Maps to: Final Loan O/s
            "principalOverdue": " OD_PRN ",                   // Maps to: OD_PRN
            "interestOrPEMIOverdue": " OD_INT ",              // Maps to: OD_INT

            // Processing Fees
            "processingFeesCollected": "Processing fees collected",      // Maps to: Processing fees collected
            "indASProcessingFees": " Ind AS processing fees ",           // Maps to: Ind AS processing fees

            // Classifications
            "assetClassificationRBI": "Asset classification as per RBI",        // Maps to: Asset classification as per RBI
            "assetClassificationIndAS": "Asset classification as per Ind AS",  // Maps to: Asset classification as per Ind AS

            // Provisioning
            "provisionPercentageRBI": "Provision % as per RBI",         // Maps to: Provision % as per RBI
            "provisionPercentageIndASPD": "PD",                         // Maps to: PD
            "provisionPercentageIndASLGD": "LGD",                       // Maps to: LGD
            "provisionAmountRBI": "Provison amount as per RBI",         // Maps to: Provison amount as per RBI
            "provisionAmountIndASLGD": " Provison amount as per Ind AS ", // Maps to: Provison amount as per Ind AS
            "outstandingIndAS": " Outstanding as per Ind AS ",          // Maps to: Outstanding as per Ind AS
            "outstandingUndrawnCommitment": " O/s Undrawn commitment ", // Maps to: O/s Undrawn commitment
            "provisionAmountUndrawnCommitment": " Provision on undrawn commitment ", // Maps to: Provision on undrawn commitment
            "cumulativeDisbursement": "Cummulative disbursement",       // Maps to: Cummulative disbursement

            "bifurcation": "Loan - Bifurcation (Amortized cost/FVOCI)*",
            "collateralType": "Collateral type*",
            "collateralAmount": "Collateral amount*",
            "fairValueCollateralAmount": "Fair value of Collateral amount*",
            "industryClassification": "Industry classification*",
            "sectorClassification": "Sector wise classification*",
            "outstandingWriteOff": "O/s Write off",
            "ECLWriteOff": "ECL Write off"
        })
    }, [])


    useEffect(() => {

        // // This code inside useEffect will run only once after the component first mounts.
        // setloansColumnMapVal({
        //     // Basic Customer and Loan Identifiers
        //     "customerID":"",
        //     "customerName":"",
        //     "productID":"",
        //     "productName":"",
        //     "loanID":"",
        //     "loanName":"",
        //     "sanctionAmount":"",
        //     "sanctionDate":"",
        //     "sanctionedROI":"",
        //     "currentOrRevisedROI":"",
        //     "sanctionedNumberOfMonths":"",
        //     "remainingNumberOfMonths":"",
        //     "overdueDays":"",
        //     "loanOutstanding":"",
        //     "principalOverdue":"",
        //     "interestOrPEMIOverdue":"",
        //     "processingFeesCollected":"",
        //     "indASProcessingFees":"",
        //     "assetClassificationRBI":"",
        //     "assetClassificationIndAS":"",
        //     "provisionPercentageRBI":"",
        //     "provisionPercentageIndASPD":"",
        //     "provisionPercentageIndASLGD":"",
        //     "provisionAmountRBI":"",
        //     "provisionAmountIndASLGD":"",
        //     "outstandingIndAS":"",
        //     "outstandingUndrawnCommitment":"",
        //     "provisionAmountUndrawnCommitment":"",
        //     "cumulativeDisbursement":"",
        //     "bifurcation":"",
        //     "collateralType":"",
        //     "collateralAmount":"",
        //     "fairValueCollateralAmount":"",
        //     "industryClassification":"",
        //     "sectorClassification":"",
        //     "outstandingWriteOff":"",
        //     "ECLWriteOff":""
        // });

    }, []);

    const [filterOptions, setFilterOptions] = useState({});
    useEffect(() => {
        const getFilterOptions = async () => {
            try {
                const response = await loansListing(loanID);
                const allLoans = response.data.loanListing;

                // Create a single object with all unique values
                const uniqueOptions = {
                    customerIDs: [...new Set(allLoans.map(loan => loan.customerID))],
                    customerNames: [...new Set(allLoans.map(loan => loan.customerName))],
                    productIDs: [...new Set(allLoans.map(loan => loan.productID))],
                    productNames: [...new Set(allLoans.map(loan => loan.productName))],
                    loanIDs: [...new Set(allLoans.map(loan => loan.loanID))],
                };

                // Update the state with the single object
                setFilterOptions(uniqueOptions);
                console.log("Filter options:", uniqueOptions);
            } catch (error) {
                console.error("Failed to fetch filter options:", error);
            }
        };
        getFilterOptions();
    }, [loanID]);

    // Loans listing api 
    useEffect(() => {
        getLoansListingData(loanID, filterLoanData)
    },
        []);
    loansListing(loanID, {}).then((res) => { })
    const getLoansListingData = (loanID, filterLoanData) => {
        loansListing(loanID, filterLoanData).then((res) => {
            const displayHeaderMap = {

                // Common transformations (adjust keys based on your actual API response)
                "customerID": "CUSTOMER ID",
                "customerName": "CUSTOMER NAME",
                "productID": "PRODUCT ID", // Assuming the API returns it with space already
                "productName": "PRODUCT NAME", // Assuming the API returns it with space already
                "loanID": "LOAN ID",
                "loanName": "LOAN NAME",
                "sanctionAmount": "SANCTION AMOUNT",
                "sanctionDate": "SANCTION DATE",
                "sanctionedROI": "SANCTIONED ROI",
                "currentOrRevisedROI": "CURRENT/REVISED ROI",
                "sanctionedNumberOfMonths": "SANCTIONED NUMBER OF MONTHS",
                "remainingNumberOfMonths": "REMAINING NUMBER OF MONTHS",
                "overdueDays": "OVERDUE DAYS",
                "loanOutstanding": "LOAN OUTSTANDING",
                "principalOverdue": "PRINCIPAL OVERDUE",
                "interestOrPEMIOverdue": "INTEREST/PEMI OVERDUE",
                "processingFeesCollected": "PROCESSING FEES COLLECTED",
                "indASProcessingFees": "IND AS PROCESSING FEES O/S", // Assuming this is for outstanding
                "assetClassificationRBI": "ASSET CLASSIFICATION AS PER RBI",
                "assetClassificationIndAS": "ASSET CLASSIFICATION AS PER IND AS",
                "provisionPercentageRBI": "PROVISION % AS PER RBI",
                "provisionPercentageIndASPD": "PROVISION % AS PER IND AS - PD",
                "provisionPercentageIndASLGD": "PROVISION % AS PER IND AS - LGD",
                "provisionAmountRBI": "PROVISION AMOUNT AS PER RBI",
                "provisionAmountIndASLGD": "PROVISION AMOUNT AS PER IND AS - LGD", // Assuming this corresponds to provisionAmountIndASLGD
                "outstandingIndAS": "OUTSTANDING AS PER IND AS",
                "outstandingUndrawnCommitment": "O/S UNDRAWN COMMITMENT",
                "provisionAmountUndrawnCommitment": "PROVISION ON UNDRAWN COMMITMENT",
                "cumulativeDisbursement": "CUMULATIVE DISBURSEMENT",
                "bifurcation": "LOAN - BIFURCATION (AMORTIZED COST/FVOCI)",
                "collateralType": "COLLATERAL TYPE",
                "collateralAmount": "COLLATERAL AMOUNT",
                "fairValueCollateralAmount": "FAIR VALUE OF COLLATERAL AMOUNT",
                "industryClassification": "INDUSTRY CLASSIFICATION",
                "sectorClassification": "SECTOR WISE CLASSIFICATION",
                "outstandingWriteOff": "O/S WRITE OFF",
                "ECLWriteOff": "ECL WRITE OFF",
                // Add any other backend headers that need transformation here.
                // If a backend header is not in this map, it will be displayed as is.
            };
            const headers = res.data.loanListingHeaders.map((h) => ({
                // header: h,
                header: displayHeaderMap[h] || h,
                accessor: h,
            }));
            setloansListThData(headers);
            setloansListTbData(res.data.loanListing);

            if (res.data.filterAndAlignment) {
                setFilterAttr(res.data.filterAndAlignment);
            }
        });
    }

    const fileInputRef = useRef(null);
    const handleManualUpload = () => {
        fileInputRef.current.click();
    };

    // arranging data in to object to send api
    const handleSelectChange = (keyName, selectedOption) => {
        // keyName will be "customerID", "customerName", "productID", etc.
        // selectedOption will be the object from react-select (e.g., { value: "Actual Excel Column Name", label: "Actual Excel Column Name" })

        setloansColumnMapVal(prevMapping => ({
            ...prevMapping, // Keep all the previous key-value pairs
            [keyName]: selectedOption ? selectedOption.value : '' // Update only the specific key with the new selected value
        }));
    };


    // getting loans data
    const GetLoanMappingData = () => {
        GetLoanMapping(loanID).then((res) => {
            let loansFieldsLst = res.data.fields

            // Map loan list to dropdown format
            const formattedOptions = loansFieldsLst.map(loansFieldsLst => ({
                value: loansFieldsLst,
                label: loansFieldsLst
            }));

            setloansColumnMap(formattedOptions);
            setloanMapping(true)

        })
    }


    // sending loans mapping object
    const saveColumnMapping = () => {
        saveLoanMapping(loanID, loansColumnMapVal).then(res => {
            // hide the loan mapping
            setloanMapping(false)

            // get the sub mapping data 
            GetSubLoanMappingData()

            // un hide the sub loan mapping
            setsubloanMapping(true)
        })
    }


    // getting sub Mapping data
    const GetSubLoanMappingData = () => {

        GetSubLoanMapping(loanID, 'IndAS').then((res) => {
            let loansFieldsLst = res.data.fields
            let labelList = res.data.labelList

            // Map loan list to dropdown format
            const formattedOptions = loansFieldsLst.map(loansFieldsLst => ({
                value: loansFieldsLst,
                label: loansFieldsLst
            }));

            setperIndAsFields(formattedOptions);
            setperIndAsLabels(labelList)
        })

        GetSubLoanMapping(loanID, 'RBI').then((res) => {
            let loansFieldsLst = res.data.fields
            let labelList = res.data.labelList

            // Map loan list to dropdown format
            const formattedOptions = loansFieldsLst.map(loansFieldsLst => ({
                value: loansFieldsLst,
                label: loansFieldsLst
            }));

            setperRBIFields(formattedOptions);
            setperRBILables(labelList)
        })

        GetSubLoanMapping(loanID, 'productClassification').then((res) => {
            let loansFieldsLst = res.data.fields
            let labelList = res.data.labelList

            // Map loan list to dropdown format
            const formattedOptions = loansFieldsLst.map(loansFieldsLst => ({
                value: loansFieldsLst,
                label: loansFieldsLst
            }));

            setperProductClassfFields(formattedOptions);
            setperProductClassfLables(labelList)
            setsubloanMapping(true)
        })

    }

    const saveSubMapping = () => {
        submapping(loanID, selectedSubMappingData).then(res => {
            setsubloanMapping(false)
            toast.success("Loans added successfully.");
        })
    }
    const handleSelect = async (type) => {
        if (type === "uploadExcelModal") {
            setShowAddRegisterModal(false);
            setLoanUploadModal(true);
        } else if (type === "erp") {
            setShowAddRegisterModal(false);
            setShowERPModal(true);
            setIsErpLoading(true);
            try {
                const res = await getAllLoansErpData(loanID);
                const list =
                    res.data?.ERPLoanList ||
                    res.data?.ERPLoansList ||
                    res.data?.data ||
                    (Array.isArray(res.data) ? res.data : []);
                setErpList(list);
            } catch (error) {
                console.error("Failed to fetch ERP loans:", error);
                setErpList([]);
            } finally {
                setIsErpLoading(false);
            }
        }
    };

    const handleSuccessERPModal = async () => {
        if (!selectedCardId) {
            setErrorPopup({
                isOpen: true,
                title: "Selection Required",
                message: "Please select an ERP package to proceed.",
            });
            return;
        }
        try {
            const selectedItem = (erpList || [])
                .flatMap((pkg, pkgIdx) => {
                    if (Array.isArray(pkg.data) && pkg.data.length > 0) {
                        return pkg.data.map((entry, entryIdx) => ({
                            ...entry,
                            _id: entry._id || `${pkg._id || pkgIdx}-${entryIdx}`,
                            packageId: pkg._id || pkg.id,
                        }));
                    }
                    return [pkg];
                })
                .find(
                    (i) =>
                        i._id === selectedCardId ||
                        i.packageId === selectedCardId ||
                        i.id === selectedCardId
                );

            const resolvedPackageId =
                selectedItem?.packageId || selectedItem?._id || selectedCardId;

            await putLoanFromERP(loanID, resolvedPackageId);
            setShowERPModal(false);
            setSelectedCardId(null);
            setShowERPSuccessModal(true);
        } catch (error) {
            console.error("Failed to pull from ERP:", error);
            setErrorPopup({
                isOpen: true,
                title: "Error",
                message:
                    error?.response?.data?.message ||
                    error?.response?.data?.error ||
                    "Failed to pull ERP data. Please try again.",
            });
        }
    };

    const handleERPComplete = () => {
        setShowERPSuccessModal(false);
        getLoansListingData(loanID, filterLoanData);
    };

    const applyLoansListingFilter = (filterParams) => {
        getLoansListingData(loanID, filterParams )
    }
    return (
        <div style={{ display: 'flex' }}>
            <LoandSideBar
                id={id}
                companyId={companyId}
                activeTab={'Loan Listing'}
            />
            <div className={loanCss.loanListingMainContainer}>
                <LoanListingHeader
                    setLoanUploadModal={setLoanUploadModal}
                    setShowAddRegisterModal={setShowAddRegisterModal}
                    filterAttr={filterAttr}
                    loanID={loanID}
                    applyLoansListingFilter={applyLoansListingFilter}
                    filterOptions={filterOptions}
                />
                <LoanListingBody
                    loansListThData={loansListThData}
                    loansListTbData={loansListTbData}
                />

                {showAddRegisterModal && (
                    <AddLoanRegister
                        onClose={() => setShowAddRegisterModal(false)}
                        handleSelect={handleSelect}
                    />
                )}

                {showERPModal && (
                    <ERPModal
                        erpList={erpList}
                        selectedCardId={selectedCardId}
                        setSelectedCardId={setSelectedCardId}
                        isLoading={isErpLoading}
                        onClose={() => {
                            setShowERPModal(false);
                            setSelectedCardId(null);
                        }}
                        onBack={() => {
                            setShowERPModal(false);
                            setSelectedCardId(null);
                            setShowAddRegisterModal(true);
                        }}
                        onProceed={handleSuccessERPModal}
                    />
                )}

                {showERPSuccessModal && (
                    <SyncERPSuccess onClose={handleERPComplete} />
                )}

                {loansUploadModal && (
                    <React.Fragment>
                        <LoansUploadModel
                            fileInputRef={fileInputRef}
                            handleManualUpload={handleManualUpload}
                            setLoanUploadModal={setLoanUploadModal}
                            loanID={loanID}
                            setloanMapping={setloanMapping}
                            GetLoanMappingData={GetLoanMappingData}
                        />
                    </React.Fragment>
                )}

                {loanMapping && (
                    <React.Fragment>
                        <LoansMappingModel
                            loansColumnMap={loansColumnMap}
                            loansColumnMapVal={loansColumnMapVal}
                            setloansColumnMapVal={setloansColumnMapVal}
                            handleSelectChange={handleSelectChange}
                            saveColumnMapping={saveColumnMapping}
                            setloanMapping={setloanMapping}
                        />
                    </React.Fragment>
                )}
                {subloanMapping && (
                    <React.Fragment>
                        <SubLoansMappingModel
                            subloanMapping={subloanMapping}
                            setsubloanMapping={setsubloanMapping}
                            subMappingActiveTab={subMappingActiveTab}
                            setsubMappingActiveTab={setsubMappingActiveTab}
                            perIndAsLabels={perIndAsLabels}
                            perIndAsFields={perIndAsFields}
                            perRBILables={perRBILables}
                            perRBIFields={perRBIFields}
                            perProductClassfLables={perProductClassfLables}
                            perProductClassfFields={perProductClassfFields}
                            handleSetSelectChange={handleSetSelectChange}
                            selectedSubMappingData={selectedSubMappingData}
                            setSelectedSubMappingData={setSelectedSubMappingData}
                            saveSubMapping={saveSubMapping}
                        />
                    </React.Fragment>
                )}

                <SuccessPopup
                    isOpen={successPopup.isOpen}
                    title={successPopup.title}
                    message={successPopup.message}
                    onClose={() =>
                        setSuccessPopup({ isOpen: false, title: "Success", message: "" })
                    }
                />

                <ErrorPopup
                    isOpen={errorPopup.isOpen}
                    title={errorPopup.title}
                    message={errorPopup.message}
                    onClose={() =>
                        setErrorPopup({ isOpen: false, title: "Error", message: "" })
                    }
                />
            </div>
        </div>
    )
}

export default ReceivablesListing;


const LoanListingHeader = ({
    setLoanUploadModal,
    setShowAddRegisterModal,
    handleClose,
    filterAttr,
    loanID,
    applyLoansListingFilter,
    filterOptions
}) => {
    const [displayModal, setDisplayModal] = useState(false);
    const [listingFilterModel, setListingFilterModel] = useState(false);

    const closeListingFilterModal = () => {
        setDisplayModal(false);
    };
    return (
        <>
            <div className={loanCss.w100}>
                <div className={loanCss.uploadLoansMainContainer}>
                </div>
                <div className={loanCss.listPageheader}>
                    <div className={loanCss.loanHeaderLeftContainer}>
                        <div className={loanCss.heading}>Loan Listing</div>
                    </div>
                    <div className={loanCss.loanHeaderRightContainer}>
                        <div className={loanCss.filterContainer}>
                            {/* <FilterIcon /> */}
                            <FilterIcon className={commoncss.clickable} width={20} height={20} onClick={() => { setListingFilterModel(true); setDisplayModal(true); }} />
                        </div>
                        <div className={loanCss.calenderContainer}>
                            <div className={loanCss.leftCalenderContainer}>
                                <div className={loanCss.calenderLabels}>
                                    From
                                </div>
                                <div className={loanCss.calenderDate}>
                                    01-01-2024
                                </div>
                                <div className={loanCss.calenderIconContainer}>
                                    <CalenderIcon />
                                </div>
                            </div>

                            <div className={loanCss.RightCalenderContainer}>
                                <div className={loanCss.calenderLabels}>
                                    To
                                </div>
                                <div className={loanCss.calenderDate}>
                                    01-01-2024
                                </div>
                                <div className={loanCss.calenderIconContainer}>
                                    <CalenderIcon />
                                </div>
                            </div>
                        </div>
                        <div className={loanCss.btnWrapper}>
                            <button
                                onClick={() => {
                                    if (setShowAddRegisterModal) {
                                        setShowAddRegisterModal(true);
                                    } else {
                                        setLoanUploadModal(true);
                                    }
                                }}
                                type="button"
                                className={loanCss.uploadPrimaryBtn}>
                                <Plus className={`${loanCss.plusIcon}`} />
                                Upload
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {listingFilterModel && displayModal && (
                <ListingFilterModel
                    handleClose={closeListingFilterModal}
                    setListingFilterModel={setListingFilterModel}

                    filterAttr={filterAttr}
                    loanID={loanID}
                    applyLoansListingFilter={applyLoansListingFilter}
                    filterOptions={filterOptions}
                />
            )}
        </>

    )
}


// const LoanListingBody = ({
//     loansListThData,
//     loansListTbData,
//     }) => {

//     return(
//         <div className={loanCss.tableContianerCust}>
//             <div className={`${loanCss.tableContainer} ${loanCss.customscroll}`}>
//                 <table className={loanCss.customTable}>
//                 <thead>
//                     <tr className={loanCss.stickyTh}>
//                         {loansListThData?.map((col, i) => (
//                             <th key={i}>{col.header}</th>
//                         ))}
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {loansListTbData?.length > 0 ? (
//                     loansListTbData?.map((row, i) => (
//                         <tr key={i}>
//                             {loansListThData?.map((col, j) => (
//                                 // <td key={j} className={loanCss.truncate}>{row[col.accessor]}</td>
//                                 <td key={j} className={j === 16 ? `${loanCss.truncate} ${loanCss.centered}`: j > 16 ? `${loanCss.truncate} ${loanCss.rightAligned}` : loanCss.truncate}>{row[col.accessor]}</td>
//                             ))}
//                         </tr>
//                     ))
//                     ) : (
//                     <tr>
//                         <td colSpan={loansListThData?.length} style={{ textAlign: "center" }}>
//                         No data found
//                         </td>
//                     </tr>
//                     )}
//                 </tbody>
//                 </table>
//             </div>
//         </div>
//     )
// }
const LoanListingBody = ({ loansListThData, loansListTbData }) => {

    useEffect(() => {
        const ths = document.querySelectorAll(`.${loanCss.stickyTh} th`);
        const rows = document.querySelectorAll(`.${loanCss.customTable} tbody tr`);

        ths.forEach((th, index) => {
            const style = window.getComputedStyle(th);

            const paddingLeft = parseFloat(style.paddingLeft) || 0;
            const paddingRight = parseFloat(style.paddingRight) || 0;
            const borderLeft = parseFloat(style.borderLeftWidth) || 0;
            const borderRight = parseFloat(style.borderRightWidth) || 0;

            // Content width of <th> = total - padding - border
            const contentWidth =
                th.offsetWidth - paddingLeft - paddingRight - borderLeft - borderRight;

            rows.forEach(row => {
                const td = row.children[index];
                const wrapper = td?.querySelector(`.${loanCss.truncateWrapper}`);
                if (wrapper) {
                    wrapper.style.maxWidth = `${contentWidth}px`;
                }
            });
        });
    }, [loansListTbData, loansListThData]);


    const TruncCell = ({ content }) => {
        const wrapperRef = useRef(null);
        const [tooltip, setTooltip] = useState(null);
        const [maxWidth, setMaxWidth] = useState(null);

        useEffect(() => {
            if (wrapperRef.current) {
                const td = wrapperRef.current.closest("td");
                if (td) {
                    const style = window.getComputedStyle(td);
                    const paddingLeft = parseFloat(style.paddingLeft) || 0;
                    const paddingRight = parseFloat(style.paddingRight) || 0;

                    // clientWidth excludes borders but includes padding
                    const innerWidth = td.clientWidth - paddingLeft - paddingRight;
                    setMaxWidth(innerWidth);
                }
            }
        }, []);

        const isTruncated = () => {
            const el = wrapperRef.current;
            return el && el.scrollWidth > el.clientWidth;
        };

        const handleMouseEnter = (e) => {
            if (!isTruncated()) return;
            const rect = e.target.getBoundingClientRect();
            setTooltip({
                text: content,
                x: rect.left + rect.width / 2,
                y: rect.top
            });
        };

        const handleMouseLeave = () => setTooltip(null);

        return (
            <>
                <div
                    ref={wrapperRef}
                    style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        boxSizing: "border-box",
                        maxWidth: maxWidth ? `${maxWidth}px` : "100%"
                    }}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    {content}
                </div>

                {tooltip && (
                    <div
                        style={{
                            position: "fixed",
                            top: tooltip.y - 28,
                            left: tooltip.x,
                            transform: "translateX(-50%)",
                            backgroundColor: "#333",
                            color: "#fff",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            fontSize: "12px",
                            whiteSpace: "nowrap",
                            zIndex: 9999,
                            pointerEvents: "none"
                        }}
                    >
                        {tooltip.text}
                    </div>
                )}
            </>
        );
    };

    return (
        <div className={loanCss.tableContianerCust}>
            <div className={`${loanCss.tableContainer} ${loanCss.customscroll}`}>
                <table className={loanCss.customTable}>
                    <thead>
                        <tr className={loanCss.stickyTh}>
                            {loansListThData?.map((col, i) => (
                                <th key={i}>{col.header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {loansListTbData?.length > 0 ? (
                            loansListTbData?.map((row, i) => (
                                <tr key={i}>
                                    {loansListThData?.map((col, j) => (
                                        // <td key={j} className={loanCss.truncate}>{row[col.accessor]}</td>
                                        <td key={j} className={j === 16 ? `${loanCss.truncate} ${loanCss.centered}` : j > 16 ? `${loanCss.truncate} ${loanCss.rightAligned}` : loanCss.truncate}>

                                            {/* <div className={loanCss.truncateWrapper}> {row[col.accessor]} </div> */}
                                            <TruncCell content={row[col.accessor]} />


                                        </td>


                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={loansListThData?.length} style={{ textAlign: "center" }}>
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

const LoansUploadModel = ({
    setLoanUploadModal,
    fileInputRef,
    handleManualUpload,
    loanID,
    setloanMapping,
    GetLoanMappingData
}) => {
    const [dragActive, setDragActive] = useState(false);
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false); // New state for tracking upload status
    const [uploadError, setUploadError] = useState(null);

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files[0]) {
            setFile(e.dataTransfer.files[0]);
        }
    };

    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };

    const handleRemoveFile = () => {
        setFile(null);
        // Crucial fix: Clear the input's value to allow re-uploading the same file
        if (fileInputRef.current) {
            fileInputRef.current.value = null; // or ''
        }
    };

    const uploadFileToApi = async () => {
        if (!file) {
            setUploadError("Please select a file to upload.");
            return;
        }

        if (!loanID) {
            setUploadError("Loan ID is missing. Cannot upload file.");
            return;
        }

        setUploading(true);
        setUploadError(null);

        const formData = new FormData();
        formData.append('file', file); // Key 'file' matches your Postman setup and backend expectation

        try {
            // Call your API function
            const result = await UploadLoanFiles(loanID, formData); // Pass loanID and formData
            console.log('Upload successful:', result);
            GetLoanMappingData()
            setLoanUploadModal(false)

        } catch (error) {
            // Error handling from the API call
            console.error('Error uploading file:', error);
            // Check if error.response exists for more specific API error messages
            const errorMessage = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : error.message || 'An unexpected error occurred during upload.';
            setUploadError(errorMessage);
        } finally {
            setUploading(false);
        }
    };

    return (
        <div
            className={`${loanCss.cutModelForDragLaonsIrac} custmfadein`}
            onClick={() => {
                setLoanUploadModal(false);
            }}
        >
            <div
                className={loanCss.cutmModelMainContainer}
                onClick={(e) => e.stopPropagation()} // prevent modal close on inside click
            >
                <div className={loanCss.custModelHeader}>
                    <div className={loanCss.custModelHeaderLabel}>Upload Loans</div>
                    <div className={loanCss.custmCursor}>
                        <CustModeLCloseIcon
                            className={`${loanCss.custModelHeaderCloseicon} ${loanCss.cursiorPointer}`}
                            onClick={() => setLoanUploadModal(false)}
                        />
                    </div>
                </div>

                <div className={loanCss.cutModelBodyContainerOne}>
                    <div
                        className={`${loanCss.dragDropArea} ${dragActive ? loanCss.dragActive : ''}`}
                        onDragEnter={handleDrag}
                        onDragOver={handleDrag}
                        onDragLeave={handleDrag}
                        onDrop={handleDrop}
                    >
                        <label htmlFor="file-upload" className={loanCss.dragDropLabel}>
                            Drag and drop your file here or
                            <button type="button"
                                onClick={handleManualUpload}
                                className={loanCss.custModelUploadBtn}>
                                <LoansUploadIcon className={loanCss.loanUploadIcon} />
                                &nbsp;
                                Upload
                            </button>
                        </label>
                        <input
                            id="file-upload"
                            type="file"
                            onChange={handleFileChange}
                            className={loanCss.hiddenFileInput}
                            ref={fileInputRef}
                        />
                    </div>

                    <div className={loanCss.loanUploadInfo}>
                        File you upload must contain all the mandatory fields for mapping.
                        {/* Display upload error message */}
                        {uploadError && (
                            <p style={{ color: 'red', marginTop: '10px' }}>{uploadError}</p>
                        )}

                    </div>

                    {file && (
                        <p className={`${loanCss.selectedFile} ${loanCss.fileUploadedIcon}`}>
                            File Name  {file.name}
                            <span className={loanCss.fileRmIcon}
                                onClick={() => {
                                    // setFile(null)
                                    handleRemoveFile();
                                }}
                            >
                                <RemoveLoanIcon />
                            </span>
                        </p>
                    )}
                </div>

                <div className={loanCss.cutModelFooterContainer}>
                    <button
                        type="button"
                        onClick={() => setLoanUploadModal(false)}
                        className={loanCss.custModelFooterBtnSecondary}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={uploadFileToApi}
                        className={loanCss.custModelFooterBtnPrimary}
                        disabled={uploading || !file || !loanID} // Disable if no file or no loanID
                    >
                        {uploading ? 'Uploading...' : 'Proceed'}
                    </button>
                </div>
            </div>
        </div>
    );
};


const LoansMappingModel = ({
    loansColumnMap,
    loansColumnMapVal,
    setloansColumnMapVal,
    handleSelectChange,
    saveColumnMapping,
    setloanMapping
}) => {

    return (
        <div
            className={`${loanCss.cutModelForDragLaonsIrac} custmfadein`}
            onClick={() => { }}>
            <div
                className={loanCss.cutmModelMainContainerSecond}
                onClick={(e) => e.stopPropagation()} // prevent modal close on inside click
            >
                <div className={loanCss.custModelHeader}>
                    <div className={loanCss.custModelHeaderLabel}>Map Column headers</div>
                    <div className={loanCss.custmCursor}>
                        <CustModeLCloseIcon
                            className={`${loanCss.custModelHeaderCloseicon} ${loanCss.cursiorPointer}`}
                            onClick={() => { setloanMapping(false); }}
                        />
                    </div>
                </div>

                <div className={`${loanCss.cutModelBodyContainer} ${loanCss.customscroll}`}>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Customer ID
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                // value={loansColumnMapVal?.val ? loansColumnMap.find(option => option.value === loansColumnMapVal?.val) : ''}
                                value={loansColumnMapVal['customerID'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['customerID']) : null}
                                onChange={(selectedOption) => handleSelectChange('customerID', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Customer Name
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['customerName'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['customerName']) : null}
                                onChange={(selectedOption) => handleSelectChange('customerName', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Product ID
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['productID'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['productID']) : null}
                                onChange={(selectedOption) => handleSelectChange('productID', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Product name
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['productName'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['productName']) : null}
                                onChange={(selectedOption) => handleSelectChange('productName', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Loan ID
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['loanID'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['loanID']) : null}
                                onChange={(selectedOption) => handleSelectChange('loanID', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Loan Name
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['loanName'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['loanName']) : null}
                                onChange={(selectedOption) => handleSelectChange('loanName', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Sanction Amount
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['sanctionAmount'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['sanctionAmount']) : null}
                                onChange={(selectedOption) => handleSelectChange('sanctionAmount', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Sanction Date
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['sanctionDate'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['sanctionDate']) : null}
                                onChange={(selectedOption) => handleSelectChange('sanctionDate', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Sanction ROI
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['sanctionedROI'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['sanctionedROI']) : null}
                                onChange={(selectedOption) => handleSelectChange('sanctionedROI', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Current/Revised ROI
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['currentOrRevisedROI'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['currentOrRevisedROI']) : null}
                                onChange={(selectedOption) => handleSelectChange('currentOrRevisedROI', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Sanctioned no.of months
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['sanctionedNumberOfMonths'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['sanctionedNumberOfMonths']) : null}
                                onChange={(selectedOption) => handleSelectChange('sanctionedNumberOfMonths', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Remaining no.of months
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['remainingNumberOfMonths'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['remainingNumberOfMonths']) : null}
                                onChange={(selectedOption) => handleSelectChange('remainingNumberOfMonths', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Overdue Days
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['overdueDays'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['overdueDays']) : null}
                                onChange={(selectedOption) => handleSelectChange('overdueDays', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Loan Outstanding
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['loanOutstanding'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['loanOutstanding']) : null}
                                onChange={(selectedOption) => handleSelectChange('loanOutstanding', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Principle Overdue
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['principalOverdue'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['principalOverdue']) : null}
                                onChange={(selectedOption) => handleSelectChange('principalOverdue', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Interest/PEMI overdue
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['interestOrPEMIOverdue'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['interestOrPEMIOverdue']) : null}
                                onChange={(selectedOption) => handleSelectChange('interestOrPEMIOverdue', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Processing fee collected
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['processingFeesCollected'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['processingFeesCollected']) : null}
                                onChange={(selectedOption) => handleSelectChange('processingFeesCollected', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Ind AS processing fees O/s
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['indASProcessingFees'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['indASProcessingFees']) : null}
                                onChange={(selectedOption) => handleSelectChange('indASProcessingFees', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Asset Classification as per RBI
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['assetClassificationRBI'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['assetClassificationRBI']) : null}
                                onChange={(selectedOption) => handleSelectChange('assetClassificationRBI', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Asset Classification as per Ind AS
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['assetClassificationIndAS'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['assetClassificationIndAS']) : null}
                                onChange={(selectedOption) => handleSelectChange('assetClassificationIndAS', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Provision % as per RBI
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['provisionPercentageRBI'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['provisionPercentageRBI']) : null}
                                onChange={(selectedOption) => handleSelectChange('provisionPercentageRBI', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Outstanding as per Ind AS
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['outstandingIndAS'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['outstandingIndAS']) : null}
                                onChange={(selectedOption) => handleSelectChange('outstandingIndAS', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Provision % as per Ind AS - PD
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['provisionPercentageIndASPD'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['provisionPercentageIndASPD']) : null}
                                onChange={(selectedOption) => handleSelectChange('provisionPercentageIndASPD', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Provision Amount as per RBI
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['provisionAmountRBI'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['provisionAmountRBI']) : null}
                                onChange={(selectedOption) => handleSelectChange('provisionAmountRBI', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Provision on undrawn commitment
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['outstandingUndrawnCommitment'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['outstandingUndrawnCommitment']) : null}
                                onChange={(selectedOption) => handleSelectChange('outstandingUndrawnCommitment', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                O/s Undrawn Commitment
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['provisionAmountUndrawnCommitment'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['provisionAmountUndrawnCommitment']) : null}
                                onChange={(selectedOption) => handleSelectChange('provisionAmountUndrawnCommitment', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Cumulative Disbursement
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['cumulativeDisbursement'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['cumulativeDisbursement']) : null}
                                onChange={(selectedOption) => handleSelectChange('cumulativeDisbursement', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Provision % as per Ind AS - LGD
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['provisionPercentageIndASLGD'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['provisionPercentageIndASLGD']) : null}
                                onChange={(selectedOption) => handleSelectChange('provisionPercentageIndASLGD', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Collateral type
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['collateralType'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['collateralType']) : null}
                                onChange={(selectedOption) => handleSelectChange('collateralType', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Industry classification
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['industryClassification'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['industryClassification']) : null}
                                onChange={(selectedOption) => handleSelectChange('industryClassification', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Provision amount as per Ind AS - LGD
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['provisionAmountIndASLGD'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['provisionAmountIndASLGD']) : null}
                                onChange={(selectedOption) => handleSelectChange('provisionAmountIndASLGD', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Collateral amount
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['collateralAmount'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['collateralAmount']) : null}
                                onChange={(selectedOption) => handleSelectChange('collateralAmount', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Sector wise classification
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['sectorClassification'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['sectorClassification']) : null}
                                onChange={(selectedOption) => handleSelectChange('sectorClassification', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Loan - Bifurcation (Amortized cost/FVOCI)
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['bifurcation'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['bifurcation']) : null}
                                onChange={(selectedOption) => handleSelectChange('bifurcation', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                Fair value of Collateral amount
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['fairValueCollateralAmount'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['fairValueCollateralAmount']) : null}
                                onChange={(selectedOption) => handleSelectChange('fairValueCollateralAmount', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                O/s Write off
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['outstandingWriteOff'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['outstandingWriteOff']) : null}
                                onChange={(selectedOption) => handleSelectChange('outstandingWriteOff', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={loanCss.selectRowContainer}>
                        <div className={loanCss.selectContainer}>
                            <div className={loanCss.custmLabel}>
                                <span className={loanCss.reqiredField}>*</span>
                                ECL Write off
                            </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={loansColumnMapVal['ECLWriteOff'] ? loansColumnMap.find(option => option.value === loansColumnMapVal['ECLWriteOff']) : null}
                                onChange={(selectedOption) => handleSelectChange('ECLWriteOff', selectedOption)}
                                options={loansColumnMap}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                </div>

                <div className={loanCss.cutModelFooterContainer}>
                    <button
                        type="button"
                        onClick={() => { setloanMapping(false); }}
                        className={loanCss.custModelFooterBtnSecondary}
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        onClick={() => { saveColumnMapping() }}
                        className={loanCss.custModelFooterBtnPrimary}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    );
};


const SubLoansMappingModel = ({
    setsubloanMapping,
    subloanMapping,
    subMappingActiveTab,
    setsubMappingActiveTab,
    perIndAsLabels,
    perIndAsFields,
    perProductClassfLables,
    perProductClassfFields,
    perRBILables,
    perRBIFields,
    handleSetSelectChange,
    selectedSubMappingData,
    setSelectedSubMappingData,
    saveSubMapping
}) => {

    return (
        <div
            className={`${loanCss.cutModelForDragLaonsIrac} custmfadein`}
            onClick={() => { }}>
            <div
                className={loanCss.cutmModelMainContainerThird}
                onClick={(e) => e.stopPropagation()} // prevent modal close on inside click
            >
                <div className={loanCss.custModelHeader}>
                    <div className={loanCss.custModelHeaderLabel}>Sub Mapping</div>
                    <div className={loanCss.custmCursor}>
                        <CustModeLCloseIcon
                            className={`${loanCss.custModelHeaderCloseicon} ${loanCss.cursiorPointer}`}
                            onClick={() => { setsubloanMapping(false) }}
                        />
                    </div>
                </div>

                {/* subMappingActiveTab, setsubMappingActiveTab */}
                <div className={loanCss.wrapperContainerSubMap}>
                    <div className={loanCss.loansSubMapTabsContainer}>
                        <div onClick={() => { setsubMappingActiveTab(1) }} className={subMappingActiveTab === 1 ? loanCss.subMapTabsActive : loanCss.subMapTabs}>Asset Classification as per RBI</div>
                        <div onClick={() => { setsubMappingActiveTab(2) }} className={subMappingActiveTab === 2 ? loanCss.subMapTabsActive : loanCss.subMapTabs}>Asset Classification as per Ind AS</div>
                        <div onClick={() => { setsubMappingActiveTab(3) }} className={subMappingActiveTab === 3 ? loanCss.subMapTabsActive : loanCss.subMapTabs}>Product Classification</div>
                    </div>
                    {
                        subMappingActiveTab === 1 ?
                            <div className={`${loanCss.selectContainerWrapper} ${loanCss.customscroll}`}>
                                {perRBILables?.map((label, index) => (
                                    <div className={loanCss.selectContainerTab} key={index}>
                                        <div style={{ marginBottom: '10px' }}>{label}</div>
                                        <Select
                                            components={{ IndicatorSeparator: () => null }}
                                            key={index}
                                            value={selectedSubMappingData.RBIStages[index]?.values?.[0]
                                                ? { label: selectedSubMappingData.RBIStages[index].values[0], value: selectedSubMappingData.RBIStages[index].values[0] }
                                                : null
                                            }
                                            onChange={(selectedOption) => handleSetSelectChange(selectedOption, index, 'RBI')}
                                            options={perRBIFields} // Provide the options for the current dropdown
                                            placeholder="Select Scenario"
                                            name={`status-${index}`} // Unique name for each select
                                            className={`mt-0 ${loanCss.scenarioSelect}`}
                                            classNamePrefix="select"
                                            styles={customStyles}
                                            isClearable={false}
                                            isSearchable={false}
                                        />
                                    </div>
                                ))}
                            </div>
                            :
                            subMappingActiveTab === 2 ?
                                <div className={`${loanCss.selectContainerWrapper} ${loanCss.customscroll}`}>
                                    {perIndAsLabels?.map((label, index) => (
                                        <div className={loanCss.selectContainerTab} key={index}>
                                            <div style={{ marginBottom: '10px' }}>{label}</div>
                                            <Select
                                                components={{ IndicatorSeparator: () => null }}
                                                key={index}
                                                value={selectedSubMappingData.IndASStages[index]?.values?.[0]
                                                    ? { label: selectedSubMappingData.IndASStages[index].values[0], value: selectedSubMappingData.IndASStages[index].values[0] }
                                                    : null
                                                }
                                                onChange={(selectedOption) => handleSetSelectChange(selectedOption, index, 'IndAS')}
                                                options={perIndAsFields} // Provide the options for the current dropdown
                                                placeholder="Select Scenario"
                                                name={`status-${index}`} // Unique name for each select
                                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                                classNamePrefix="select"
                                                styles={customStyles}
                                                isClearable={false}
                                                isSearchable={false}
                                            />
                                        </div>
                                    ))}
                                </div>
                                :
                                subMappingActiveTab === 3 ?
                                    <div className={`${loanCss.selectContainerWrapper} ${loanCss.customscroll}`}>
                                        {perProductClassfLables?.map((label, index) => (
                                            <div className={loanCss.selectContainerTab} key={index}>
                                                <div style={{ marginBottom: '10px' }}>{label}</div>
                                                <Select
                                                    components={{ IndicatorSeparator: () => null }}
                                                    key={index}
                                                    value={selectedSubMappingData.productClassificationStages[index]?.values?.[0]
                                                        ? { label: selectedSubMappingData.productClassificationStages[index].values[0], value: selectedSubMappingData.productClassificationStages[index].values[0] }
                                                        : null
                                                    }
                                                    onChange={(selectedOption) => handleSetSelectChange(selectedOption, index, 'productClassification')}
                                                    options={perProductClassfFields} // Provide the options for the current dropdown
                                                    placeholder="Select Scenario"
                                                    name={`status-${index}`} // Unique name for each select
                                                    className={`mt-0 ${loanCss.scenarioSelect}`}
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    isClearable={false}
                                                    isSearchable={false}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                    : null
                    }
                </div>

                <div className={loanCss.cutModelFooterContainer}>
                    <button
                        type="button"
                        onClick={() => { setsubloanMapping(false) }}
                        className={loanCss.custModelFooterBtnSecondary}
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        onClick={() => { saveSubMapping() }}
                        className={loanCss.custModelFooterBtnPrimary}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    );
};


export const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#f4faf5',
        borderColor: '#c2e6d1',
        color: '#b3c0bd',
        boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
        borderWidth: '1px',
        borderRadius: '10px',
        '&:hover': {
            borderColor: '#b3c0bd',
        },
        minHeight: '38px',
        height: '38px',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '2px 8px',
        paddingTop: '1px',
    }),
    input: (provided) => ({
        ...provided,
        color: '#b3c0bd',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        fontSize: '14px',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4d6d64',
        fontSize: '14px',
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e0f5e9',
        borderRadius: '0.25rem',
        border: '1px solid #c2e6d1',
        width: 'fit-content',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#4d6d64',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            backgroundColor: '#c2e6d1',
            color: '#4f665f',
        },
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#b3c0bd',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#205a46',
        ':hover': {
            color: '#205a46',
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            color: '#4f665f',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#ffffff',
        border: '1px solid #c2e6d1',
        borderRadius: '10px',
        boxShadow: '0 0 0 1px #c2e6d1',
        marginTop: '6px',
        zIndex: 10,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        borderRadius: '10px',
    }),
    //   option: (provided, state) => ({
    //     ...provided,
    //     backgroundColor: state.isSelected
    //       ? '#c2e6d1'
    //       : state.isFocused
    //       ? '#f4faf5'
    //       : 'transparent',
    //     color: '#4f665f',
    //     padding: '10px 12px',
    //     cursor: 'pointer',
    //     fontSize: '14px',
    //     borderRadius: '8px',
    //     // margin: '4px 6px',
    //   }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? '#f4faf5'
            : 'transparent',
        color: '#4f665f',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: '14px',
        borderRadius: '8px',
    }),

    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};
